import { CatalogItemRelations } from '../../../components/Product/components/ProductCard/types/productCard.types';
import {
  GetProductActionDTO,
  SaleItemType,
} from '../../../components/Search/interfaces/product-action.dto';
import { OfflineDatabaseCatalogSectionItem } from '../../offline/database/offlineDatabase/types/offlineDatabaseCatalog.types';
import { CatalogSectionItem } from '../../offline/hooks/useOfflineDataDownloader/hooks/useQueryKeysAndFnToCache/utils/dynamicQueryKeysAndFnFactory/generators/types/catalogsQueryKeysAndFnGenerator.types';
import { SectionWithItemAndInfo } from '../../offline/transformers/types/OfflineDatabaseCatalog.transformers.types';

const createTypeGuard = <TUnion extends { type: string }, TType extends TUnion['type']>(
  expectedType: TType,
) => {
  return (entity: TUnion): entity is Extract<TUnion, { type: TType }> =>
    entity.type === expectedType;
};

type SaleItemTypeGuardUnion =
  | CatalogItemRelations
  | GetProductActionDTO
  | OfflineDatabaseCatalogSectionItem
  | CatalogSectionItem
  | SectionWithItemAndInfo;

export const saleItemIsProductColor = createTypeGuard<
  SaleItemTypeGuardUnion,
  SaleItemType.PRODUCT_COLOR
>(SaleItemType.PRODUCT_COLOR);

export const saleItemIsKit = createTypeGuard<SaleItemTypeGuardUnion, SaleItemType.KIT>(
  SaleItemType.KIT,
);
